import { Link } from "react-router-dom";
import { Table } from "../../../../../../components/Functional";
import { Button, Modal } from "../../../../../../components/ui";
import { UPDATE_OFFER as updateOfferMutation } from "../../../../../../graphql/mutation/Offer";
import { FETCH_OFFERS_V2 as fetchOffersV2 } from "../../../../../../graphql/query/Offer";
import EditOffer from "../../../../../Offer/pages/List/components/EditOffer";
import SectionHeader from "../../components/SectionHeader";
import Actions from "./components/Actions";

const InstanceOffers = (props = {}) => {
  const { artworkId } = props;

  const tableProps = {
    variant: "dynamicHeight",
    dataKey: "offersV2",
    headers: [
      { label: "Date", name: "date", type: "date" },
      {
        label: "Contact",
        name: "contact.name",
        type: "custom",
        component: ({ values }) => (
          <Link
            className="underline"
            to={`/contacts/${values?.contact?.id}/details`}
          >
            {values?.contact?.name || values?.contact?.id}
          </Link>
        ),
      },
      { label: "Status", name: "status.description", type: "label" },
      { label: "Currency", name: "currency.code", type: "label" },
      { label: "Amount", name: "amount", type: "currency" },
      { label: "TBI Amount", name: "tbiAmount", type: "currency" },
      {
        label: "Top Deal",
        name: "priority",
        type: "input",
        inputType: "checkbox",
        singleCheckbox: true,
        options: [{ value: -1 }],
      },
      {
        label: "Hold",
        name: "hold.name",
        type: "custom",
        component: props => {
          return (
            <Link
              className="underline"
              to={`/instance/${props?.values?.hold?.id}/details`}
            >
              {props?.values?.hold?.name}
            </Link>
          );
        },
      },
      { label: "User", name: "user", type: "label" },
      { label: "Date Closed", name: "dateClosed", type: "date" },
      { label: "Notes", name: "notes", type: "label" },
      {
        label: "",
        name: "action",
        type: "custom",
        component: props => <Actions {...props} artworkId={artworkId} />,
      },
    ],
    FETCH_QUERY: fetchOffersV2({
      contact: { name: true, id: true },
      contactId: true,
      currency: {},
      currencyId: true,
      status: {},
      statusId: true,
      hold: { name: true, id: true },
      holdId: true,
      amount: true,
      tbiAmount: true,
      tbiDate: true,
      user: true,
      date: true,
      holdDate: true,
      dateClosed: true,
      priority: true,
      notes: true,
      projectCode: true,
    }),
    variables: {
      _artwork: {
        id: {
          operator: "eq",
          value: artworkId,
        },
      },
      order: "groupByHold",
    },
    skip: () => !artworkId,
    UPDATE_MUTATION: updateOfferMutation(),
    className: "sm:px-0 lg:px-0",
  };

  const modalProps = {
    body: EditOffer,
    closeOnBackdrop: false,
    offer: { artworkId },
    hideCloseButton: false,
    scale: "lg",
  };

  const offersActions = [
    {
      component: () => {
        return (
          <Modal {...modalProps}>
            <Button label="Add Offer" action="black" />
          </Modal>
        );
      },
    },
  ];

  return (
    <div className="w-full">
      <SectionHeader title="Offers" actions={offersActions} />
      <div className="mb-6 w-full">
        <Table {...tableProps} />
      </div>
    </div>
  );
};

export default InstanceOffers;
